import { apiGet, apiPatch, apiPost } from '@forwardflow/services/Axios/configs'
import { PaginatedResponse, ResponseSuccess } from '@forwardflow/types'
import { ICRMIntegrationID } from '@forwardflow/types/crm-integration'

export default class CRMIntegrationService {
   // Verify follow up boss API key
   static verifyFUBApi = async (api: string) => {
      const data = await apiGet<ResponseSuccess<object>>({
         apiPath: `/organizations/identify-fub?token=${api}`,
         includeXOrg: false,
      })
      return data.data
   }

   // Submit Fub token

   static submitFUBToken = async (token: string, isTesting?: boolean) => {
      const data = await apiGet<ResponseSuccess<object>>({
         apiPath: `/organizations/submit?token=${token}&isTesting=${isTesting}`,
         includeXOrg: false,
      })
      return data.data
   }

   // 24 hour waiting

   static get24HourDelay = async (organizationId: string) => {
      const data = await apiGet<ResponseSuccess<{ isDisabled: boolean }>>({
         apiPath: `/organizations/${organizationId}/24-hr-ui-disabled-status`,
      })
      return data.data
   }

   // update 24 hour waiting

   static update24HourDelay = async (
      organizationId: string,
      isDisabled: boolean
   ) => {
      const data = await apiPatch<ResponseSuccess<object>>({
         apiPath: `/organizations/change-24hr-ui-disabled-status?organizationId=${organizationId}&isDisabled=${isDisabled}`,
         includeXOrg: false,
      })
      return data.data
   }

   // Get CRM Integration ID
   static getCRMIntegrationId = async () => {
      const data = await apiGet<PaginatedResponse<ICRMIntegrationID>>({
         apiPath: `/crm-integrations?search=follow-up-boss&page=1&limit=10`,
      })
      return data.data[0].id
   }

   static userCRMIntegration = async (api: string, id: string) => {
      const data = await apiPost<ResponseSuccess<object>>({
         apiPath: `/org-crm-integrations`,
         data: {
            crmIntegrationId: `${id}`,
            meta: { apiToken: `${api}` },
         },
      })
      return data.data
   }
}
